import React from 'react';

import ReportBuilder from '../components/data/report-builder';

class DataPage extends React.Component {

    render() {
        return (
            <ReportBuilder />
        )
    }

}

export default DataPage;


// WEBPACK FOOTER //
// ./src/containers/data-page.js